// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"79235dc7","318":"452b887f","491":"b8bc1875","593":"a8a7f843","692":"faf70e91","743":"2422c537","810":"48984c0c","885":"a024ce86"}[chunkId] + ".chunk.js";
};